import { trpc } from '@/shared/api';

/** 템플릿 목록·상품별 상속 결과 캐시를 함께 무효화한다. */
export const useInvalidateEditAreaTemplates = (): (() => Promise<void>) => {
  const utils = trpc.useUtils();

  return async () => {
    await Promise.all([
      utils.productManagement.editAreaTemplates.list.invalidate(),
      utils.productManagement.editAreaTemplates.forProduct.invalidate(),
    ]);
  };
};
